import TeamAssistMessage from 'models/team_assist_message';

export default class RateTeamAssistMessage {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId, rating }) {
    if (!customerId || !messageId) {
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const store = this.context.stores.customers.storesFor(customerId).teamAssists;
    const message = store.find(messageId);
    if (!message) {
      return;
    }

    const messageJs = message.toJs();
    const previousRating = messageJs.rating;
    store.addOrReplace(TeamAssistMessage.fromJs({ ...messageJs, rating }));

    this.context.gateways.teamAssist
      .update({ customerId, teamAssistId: messageId }, { rating: rating || null })
      .catch(() => {
        store.addOrReplace(TeamAssistMessage.fromJs({ ...messageJs, rating: previousRating }));
      });
  }
}
